import { useSyncExternalStore } from 'react'

/** Someone who could not be called because they haven't accepted call recording. */
export type UnconsentedCallPerson = {
  userId: string
  firstName: string
}

/**
 * Shown to the CALLER when the server refused to ring (1:1) or skipped
 * (group) people who haven't accepted call recording. The top-level
 * <RecordingConsentPeerDialog/> renders it and offers a "Send message" that
 * opens the 1:1 thread with an editable, NOT auto-sent draft.
 */
export type PendingRecordingConsentPeerNotice = {
  /** 'peer': one person, the call was not placed. 'skipped': a group call went on without them. */
  kind: 'peer' | 'skipped'
  people: UnconsentedCallPerson[]
}

let pending: PendingRecordingConsentPeerNotice | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

function getPending(): PendingRecordingConsentPeerNotice | null {
  return pending
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function showRecordingConsentPeerNotice(next: PendingRecordingConsentPeerNotice): void {
  if (next.people.length === 0) return
  pending = next
  emit()
}

export function clearRecordingConsentPeerNotice(): void {
  if (pending === null) return
  pending = null
  emit()
}

export function useRecordingConsentPeerNotice(): PendingRecordingConsentPeerNotice | null {
  return useSyncExternalStore(subscribe, getPending, getPending)
}
